import React from 'react';

import { FormControl, InputLabel, MenuItem } from '@material-ui/core';
import propTypes from 'prop-types';

import { FontSelectorWrapper, CustomSelect } from './styles';
import { availableFonts } from './suportedFonts';

export function FontSelector({ fontFamily, setFontFamily }) {
  return (
    <FontSelectorWrapper>
      <FormControl fullWidth size="small" variant="outlined">
        <InputLabel id="select-font-label">Selecione a Fonte</InputLabel>
        <CustomSelect
          labelId="select-font-label"
          label="Selecione a Fonte"
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
          }}
          onChange={(event) => setFontFamily(event.target.value)}
          value={fontFamily}
        >
          {availableFonts.map((fontData, index) => (
            <MenuItem
              key={index}
              style={{ fontFamily: fontData.value }}
              value={fontData.value}
            >
              {fontData.name}
            </MenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    </FontSelectorWrapper>
  );
}

FontSelector.propTypes = {
  fontFamily: propTypes.string.isRequired,
  setFontFamily: propTypes.func.isRequired,
};
